import { render, staticRenderFns } from "./NestedRawDisplayer.vue?vue&type=template&id=39fcc4e8&scoped=true"
import script from "./NestedRawDisplayer.vue?vue&type=script&lang=js"
export * from "./NestedRawDisplayer.vue?vue&type=script&lang=js"
import style0 from "./NestedRawDisplayer.vue?vue&type=style&index=0&id=39fcc4e8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39fcc4e8",
  null
  
)

export default component.exports